<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              需求信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <!-- <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogViewForm.typeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="市场">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求方">
                    <el-input
                      v-model="dialogViewForm.demandSide"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.type === 2"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item label="需求来源">
                    <el-input
                      v-model="dialogViewForm.schemeContent"
                      type="textarea"
                      autosize
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.type === 1"
                :gutter="10"
              >
                <el-col :span="12">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogViewForm.schemeTypeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="需求来源">
                    <el-input
                      v-model="dialogViewForm.schemeContent"
                      type="textarea"
                      autosize
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案开始日期">
                    <el-input
                      v-model="dialogViewForm.schemeStartDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求结束日期">
                    <el-input
                      v-model="dialogViewForm.schemeEndDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求物料名称">
                    <el-input
                      v-model="dialogViewForm.demandMaterialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="需求物料数量">
                    <el-input
                      v-model="dialogViewForm.demandMaterialsNumberUnit"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              申请信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="需求是否执行">
                    <el-input
                      v-model="dialogViewForm.isExecuteValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.isExecute === 1"
                  :span="6"
                >
                  <el-form-item label="需求执行方式">
                    <el-input
                      v-model="dialogViewForm.executeMethodValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.isExecute === 1"
                  :span="6"
                >
                  <el-form-item label="需求满足进度">
                    <el-input
                      v-model="dialogViewForm.materialsStatusValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.isExecute === 1 && dialogViewForm.demandSort === 1"
                :gutter="10"
              >
                <el-col :span="12">
                  <el-form-item label="物料名称">
                    <el-input
                      v-model="dialogViewForm.materialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="物料单位">
                    <el-input
                      v-model="dialogViewForm.materialsUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="申请制作数量">
                    <el-input
                      v-model="dialogViewForm.applyMakeNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 2"
                  :span="6"
                >
                  <el-form-item label="备用库存满足数量">
                    <el-input
                      v-model="dialogViewForm.applySpareStockMeetsNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货库房">
                    <el-input
                      v-model="dialogViewForm.receiveDepotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货人">
                    <el-input
                      v-model="dialogViewForm.receiver"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货联系电话">
                    <el-input
                      v-model="dialogViewForm.receivePhone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 1"
                  :span="6"
                >
                  <el-form-item label="收货地址">
                    <el-input
                      v-model="dialogViewForm.receiveAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.isExecute === 1 && dialogViewForm.demandSort === 2"
                :gutter="10"
              >
                <el-col
                  v-if="dialogViewForm.executeMethod === 3"
                  :span="12"
                >
                  <el-form-item label="租赁物料内容">
                    <el-input
                      v-model="dialogViewForm.leaseMaterials"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.executeMethod === 3"
                  :span="6"
                >
                  <el-form-item label="租赁数量">
                    <el-input
                      v-model="dialogViewForm.leaseNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="租赁备注说明">
                    <el-input
                      v-model="dialogViewForm.leaseDirections"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.isExecute === 2"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item label="不执行原因">
                    <el-input
                      v-model="dialogViewForm.ignoreReason"
                      type="textarea"
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div
            v-if="dialogViewForm.status === 4 && dialogViewForm.auditResult > 0"
            class="modal-box"
          >
            <h3 class="modal-title">
              审核确认信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="审核结果">
                    <el-input
                      v-model="dialogViewForm.auditResultValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>

                <el-col
                  v-if="dialogViewForm.auditResult === 1"
                  :span="6"
                >
                  <el-form-item label="新制作数量">
                    <el-input
                      v-model="dialogViewForm.auditMakeNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.auditResult === 1"
                  :span="6"
                >
                  <el-form-item label="供应方">
                    <el-input
                      v-model="dialogViewForm.confirmSupplierValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.auditResult === 1"
                  :span="6"
                >
                  <el-form-item label="供应商名称">
                    <el-input
                      v-model="dialogViewForm.supplierName"
                      disabled
                    />
                  </el-form-item>
                </el-col>

                <el-col
                  v-if="dialogViewForm.executeMethod === 2"
                  :span="6"
                >
                  <el-form-item label="备用库存满足数量">
                    <el-input
                      v-model="dialogViewForm.auditSpareStockMeetsNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.auditResult === 2"
                  :span="6"
                >
                  <el-form-item label="调拨满足数量">
                    <el-input
                      v-model="dialogViewForm.auditAllocateNumber"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.auditResult === 2"
                  :span="6"
                >
                  <el-form-item label="调出库房">
                    <el-input
                      v-model="dialogViewForm.auditAllocateDepotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.auditResult === 1 && dialogViewForm.executeMethod === 1"
                :gutter="10"
              >
                <el-col :span="6">
                  <el-form-item label="预计制作完成时间">
                    <el-input
                      v-model="dialogViewForm.estimatedCompleteDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="发货时间">
                    <el-input
                      v-model="dialogViewForm.shipmentDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="运输方式">
                    <el-input
                      v-model="dialogViewForm.transferMethodValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="实际到货时间">
                    <el-input
                      v-model="dialogViewForm.arrivalDateValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.auditResult === 4 || dialogViewForm.auditResult === 5"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item label="审核意见">
                    <el-input
                      v-model="dialogViewForm.auditOpinion"
                      type="textarea"
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      disabled
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建人">
                    <el-input
                      v-model="dialogViewForm.creatorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间">
                    <el-input
                      v-model="dialogViewForm.createTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提交人">
                    <el-input
                      v-model="dialogViewForm.submitterName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提交时间">
                    <el-input
                      v-model="dialogViewForm.submitTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核人">
                    <el-input
                      v-model="dialogViewForm.auditorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核时间">
                    <el-input
                      v-model="dialogViewForm.auditTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="申请状态">
                    <el-input
                      v-model="dialogViewForm.statusValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { initMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {}
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initMaterialsDemandApi({ id: this.dataId }).then(res => {
        const { data } = res
        this.dialogViewForm = data || {}
        this.dialogViewForm.demandMaterialsNumberUnit = data.demandMaterialsNumber + ' ' + data.demandMaterialsUnit

        this.loading = false
      })
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss" scoped>
.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
